package app.bloomey.web.core.data

import app.bloomey.web.core.data.models.Environment
import com.varabyte.kobweb.core.AppGlobals

object Envars {
    val environment: Environment
        get() {
            val environment = AppGlobals["SITE_ENV"]
            return Environment.entries.firstOrNull {
                it.name == environment
            } ?: Environment.production
        }
}